export const GiftInfo = ({enabled}) => {
  if (!enabled) {
    return null
  }
  return <div className="my-6">
    <p dangerouslySetInnerHTML={{__html: I18n.t('donate.gift_info')}}/>
  </div>
}
